export * from './dialog';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/md2/dialog/index.js
// module id = 873
// module chunks = 3